import { useFormContext } from 'react-hook-form';
import type { FormSchemaType } from '../../schema';

export const useTarifFormatedData = () => {
    const methods = useFormContext<FormSchemaType>();

    const Tarif = methods.watch('Tarif');
    const Devis = methods.watch('Devis');

    if (!Tarif) {
        throw new Error('Tarif not found');
    }

    const TarifVehicules = Tarif.ListeVehicules ?? Devis.ListeVehicules;
    const Formules = TarifVehicules[0].ListeFormules; // for label, ....
    const Options = Formules[0].ListeGaranties.filter((garantie) => garantie.TypeGarantie === 'Option').sort((a, b) => a.OrdreAffichage - b.OrdreAffichage);
    const Vehicules = methods.watch('DemandeTarif.ListeVehicules');
    const VehiculesMap = Vehicules.map((vehicule, vehiculeIndex) => {
        const VehiculeListeFormules = TarifVehicules[vehiculeIndex].ListeFormules;
        if (!VehiculeListeFormules) {
            throw new Error('Formules not found');
        }
        const selectedFormule = VehiculeListeFormules.find((formule) => formule.CodeFormule === vehicule.FormuleChoisie);

        if (!selectedFormule) {
            throw new Error('Formule not found');
        }

        // Pour avoir le même ordre que les garanties dans le header
        const VehiculeListeOptions = selectedFormule.ListeGaranties.filter((garantie) => garantie.TypeGarantie === 'Option').sort(
            (a, b) => Options.findIndex((garantie) => garantie.CodeGarantie === a.CodeGarantie) - Options.findIndex((garantie) => garantie.CodeGarantie === b.CodeGarantie),
        );

        const selectedOptions = VehiculeListeOptions.filter((option) => vehicule.ListeOptionsChoisies.map((option) => option.CodeOption).includes(option.CodeGarantie));
        const totalPriceVehiculeMensuel = selectedFormule.PrimeMensuelleBase + selectedOptions.reduce((acc: number, option) => acc + option.PrimeClientMensuelle, 0);
        const totalPriceVehiculeAnnuel = selectedFormule.PrimeAnnuelleFracAnnuelBase + selectedOptions.reduce((acc: number, option) => acc + option.PrimeClient, 0);

        return {
            ...vehicule,
            VehiculeListeFormules,
            VehiculeListeOptions,
            selectedFormule,
            selectedOptions,
            totalPriceVehiculeMensuel,
            totalPriceVehiculeAnnuel,
        };
    });
    const totalPrimeAnnuelle = VehiculesMap.reduce((acc: number, vehicule) => acc + vehicule.totalPriceVehiculeAnnuel, 0);
    const totalPrimeMensuelle = VehiculesMap.reduce((acc: number, vehicule) => acc + vehicule.totalPriceVehiculeMensuel, 0);

    const totalAttentat = VehiculesMap.reduce((acc: number, vehicule) => {
        if (acc > 0) {
            return acc;
        }

        return acc + vehicule.selectedFormule.MontantTaxeAttentat;
    }, 0);

    const totalPrimeMensuelleWithFrais = totalPrimeMensuelle + methods.watch('Tarif.MontantFraisDossier') / 12 + totalAttentat / 12;
    const totalPrimeAnnuelleWithFrais = totalPrimeAnnuelle + methods.watch('Tarif.MontantFraisDossier') + totalAttentat;


    return {
        Formules,
        Options,
        Vehicules,
        VehiculesMap,
        totalPrimeAnnuelle,
        totalPrimeMensuelle,
        totalAttentat,
        totalPrimeMensuelleWithFrais,
        totalPrimeAnnuelleWithFrais,
    };
};
